import { FC } from 'react';

import { Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import CheckIcon from '~/assets/icons/CheckIcon';
import ThumbDownIcon from '~/assets/icons/ThumbDownIcon';
import ThumbUpIcon from '~/assets/icons/ThumbUpIcon';
import IKImage from '~/components/IKImage/IKImage';
import { SMALL_RADIUS_PX, TINY_MARGIN_PX } from '~/theme';

const createIconStyles = <T extends {}>(component: FC<T>) => styled(component)<{
  onClick?: Function;
}>`
  width: 24px;
  height: 24px;
  cursor: ${({ onClick }) => onClick && 'pointer'};
`;

export const CustomThumbDownIcon = createIconStyles(ThumbDownIcon);
export const CustomThumbUpIcon = createIconStyles(ThumbUpIcon);
export const PreviewWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'isNotWatched',
})<{ active?: boolean; isNotWatched?: boolean }>`
  position: relative;
  height: 82px;
  margin-bottom: ${TINY_MARGIN_PX};
  overflow: hidden;
  border: ${({ active, theme }) => active && `2px solid ${theme.palette.common.accent}`};
  border-radius: ${SMALL_RADIUS_PX};
  box-sizing: border-box;

  &:after {
    content: '';
    display: ${({ active, isNotWatched }) => (active || isNotWatched ? 'none' : 'block')};
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: ${({ theme }) => theme.palette.common.card.overlay.contrast};
    opacity: 0.6;
  }

  &:before {
    content: '';
    display: ${({ active }) => (active ? 'none' : 'block')};
    position: absolute;
    bottom: 0;
    left: 0;
    height: 60%;
    width: 100%;
    background: linear-gradient(
      0deg,
      ${({ theme }) => theme.palette.common.card.overlay.contrast} 12.5%,
      ${({ theme }) => alpha(theme.palette.common.card.overlay.contrast, 0.0001)} 100%
    );
  }
`;
export const VideoPreview = styled(IKImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const PreviewTitle = styled(Typography)`
  font-size: 12px;
  line-height: 12px;
  transition: 0.3s color;
  color: inherit;
`;
export const StyledCheckIcon = styled(CheckIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
  background: ${({ theme }) => theme.palette.common.green};
  border-radius: 50%;
  color: ${({ theme }) => theme.palette.common.blueDark};
  padding: 7px;

  & polyline {
    stroke-width: 3;
  }
`;
